// core/services/api-base.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiBaseService {
  protected readonly apiUrl = environment.API_BASE_URL;

  constructor(protected http: HttpClient) {}

  protected buildUrl(...segments: (string | number)[]): string {
    return [this.apiUrl, ...segments].join('/').replace(/([^:])\/\//g, '$1/');
  }

  protected getSseStream(url: string): Observable<string[]> {
    return this.http
      .get<any>(url, {
        observe: 'events',
        reportProgress: true,
        responseType: 'text' as 'json',
      })
      .pipe(
        filter((e: any) => e.type === HttpEventType.Response && e.body),
        map((e) => e.body.trim().split(/\r\n|\r|\n/)),
      );
  }
}
